@if (showEnableConfirmation) {
  <app-experience-people-tab [showExperienceNow]="showEnableConfirmation"/>
}
<div class="modal fade" id="enable-peoples-tab-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': showPeopleTabConfimation ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content h-90">
      <div class="modal-header">
        <button type="button" class="close btn-pos" data-dismiss="modal" (click)="enablePeopleTab(false,'closeBtn')">
          <span class="NeueFile_Cancel"></span>
          <span class="esc">esc</span>
        </button>
        <img class="img-fluid" src="https://static.jiocloud.com/web2.0/common/images/people-tab-consent.png" alt="spinner-arrow" />
      </div>

      <div class="modal-body pt-4 pb-4">
        <div class="enable-peoples-tab-details">
          <h2>AI-Powered Features</h2>
          <p>JioAICloud uses AI to enhance your experience. Get ready for a fresh perspective on your photos.</p>

          <p class="mb-0">For experiencing our AI features, your consent to the following:</p>
          <ul>
            <li><strong>Data Analysis:</strong> We may analyze your photos and associated metadata to provide personalized features.</li>
            <li><strong>AI-Powered Features:</strong>These features may include face grouping, object tagging, personalised memories and suggested albums. 
              <a href="https://static.jiocloud.com/ai-people.html" rel="noreferrer noopener" target="_blank" (click)="learnMore()">Learn more</a></li>
            <li><strong>Data Privacy:</strong>Your data is processed securely and in accordance with our privacy policy.</li>
          </ul>
          <p>You can opt out of AI-powered features anytime from the Settings section of the app.</p>          
        </div>
      </div>
      <div class="modal-footer pt-0">
        <!-- Button -->
        <div class="btn-wrap">
          <button class="btn btn-enable" id="enable" title="Enable feature" data-dismiss="modal" (click)="enablePeopleTab(true,'skipBtn')">Agree</button>
          <button class="btn btn-skip mr-md-3 mb-3 mb-md-0" title="Skip for now" id="skip" (click)="enablePeopleTab(false,'enableNBtn')">Skip</button>
          
        </div>
      </div>
    </div>
  </div>
</div>